interface StringCellProps {
  value: string;
}

export function StringCell({ value }: StringCellProps) {
  return <div className="font-medium">{value}</div>;
}
